import {Directive, ElementRef, OnInit} from '@angular/core';

@Directive({
  selector: '[appFocus]'
})
export class FocusDirective implements OnInit {

  constructor(private element: ElementRef) {
  }

  ngOnInit(): void {
    setTimeout(() => {
      if (this.element && this.element.nativeElement && this.element.nativeElement.focus)
        this.element.nativeElement.focus();
    });
  }
}
